export enum FlightArrivalPolicyEnum {
  SAME_DAY = 'SAME_DAY',
  TOMORROW = 'TOMORROW',
}
